import { useEffect, useState } from 'react';
import { useAuthStore } from '../../stores/authStore';

export default function Natumia() {
  const { user } = useAuthStore();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Preparing the Natumia experience for you.');

  useEffect(() => {
    setStatus('ready');
    setMessage(
      'Natumia is now available as a React page in the AWTF frontend. Use this screen to implement Natumia workflows, payments, or integrations.'
    );
  }, []);

  return (
    <div>
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="text-3xl font-bold text-slate-900">Natumia</h1>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
            A dedicated page for Natumia flows inside the React frontend.
          </p>
        </div>

        <div className="rounded-3xl border border-slate-200 bg-white px-5 py-3 shadow-sm">
          <p className="text-sm text-slate-500">Signed in as {user?.full_name || user?.email || 'AWTF user'}</p>
          <p className="mt-1 text-xs uppercase tracking-[0.22em] text-slate-400">{user?.role || 'member'}</p>
        </div>
      </div>

      <div className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
        <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-sm uppercase tracking-[0.24em] text-orange-600">Natumia</p>
            <h2 className="mt-2 text-2xl font-semibold text-slate-900">Ready for your next action.</h2>
          </div>
          <span className="inline-flex rounded-full bg-orange-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-orange-600">
            {status}
          </span>
        </div>

        <p className="text-sm leading-7 text-slate-600">{message}</p>

        <div className="mt-6 grid gap-4 sm:grid-cols-2">
          <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-5">
            <h3 className="text-base font-semibold text-slate-900">Build Natumia workflows</h3>
            <p className="mt-2 text-sm text-slate-600">
              Add the Natumia forms, actions, and API integration you need for your project.
            </p>
          </div>
          <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-5">
            <h3 className="text-base font-semibold text-slate-900">Reuse AWTF services</h3>
            <p className="mt-2 text-sm text-slate-600">
              Connect to the existing frontend API layer in <code>src/services/api.js</code> for backend requests.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
